export default "__VITE_ASSET__CVKYIFBB__"